import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductDetailsCard, ConfirmModal, Typography } from "mobily-ui-library";

import OrderSummary from "../OrderSummary/OrderSummary";
import { GlobalContext } from "../../context/GlobalContext";

import { deleteCartItemApi, graphqlApi, captureData, removeAppleCare, POQ } from "../../api/api.ts";
import { deleteCookie } from "../../Util/deleteCookies";

import { handleApiError } from "../../functions/handleApiError";
import captureStructure from '../../captureStructure.json';
import ErrorModal from '../ErrorModal/ErrorModal';

import CloseIcon from "../../assets/closeIcon.svg";

import ShadowContainer from "../ShadowContainer/ShadowContainer";
import AppleCareImage from "../AppleCareImage/AppleCareImage";
import ExclamMark from '../../assets/ExclamMark.svg'
import AppleCoverage from "../AppleCoverage/AppleCoverage";
import "./CartPage.scss";

interface Props {
    rtl: boolean;
    productId: any;
    setShoppingCartId: (id: string) => void;
    againGraphQl: boolean;
    tamaraFee: string;
    setEmptyFlag: (flag: boolean) => void;
    currentTime: number;
    isfindInBranch: boolean;
    setIsFindInBranch: (flag: boolean) => void;
    setPreBackOrderDisabled: (flag: boolean) => void;
    soldOut: boolean;
    preBackOrderDisabled: boolean;
}

const win: any = window;
const checkoutUrl = win["checkoutUrl"];

win.dataLayer = win.dataLayer || [];

const getRemainingTime = (
    endDate: string,
    currentTime: number
) => {
    const diff = new Date(endDate).getTime() - currentTime;

    if (diff <= 0) return "";

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return `${hours}h : ${minutes}m : ${seconds}s`;
};


function CartPage({ rtl, productId, setShoppingCartId, againGraphQl, tamaraFee, setEmptyFlag, currentTime, isfindInBranch, setIsFindInBranch, setPreBackOrderDisabled, soldOut, preBackOrderDisabled }: Props) {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { scData, appleCareApplied, isSubsidyApplied, isInstallmentApplied, selectedAcPlan, isFTIApplied, forwardTradeInData } = state;
    const [color, setColor] = useState("");
    const [capacity, setCapacity] = useState("");
    const [productName, setProductName] = useState("");
    const [productImage, setProductImage] = useState("");
    const [deleteModal, setDeleteModal] = useState(false);
    const [preOrderElgibility, setPreOrderElgibility] = useState("false");
    const [isOutOfStock, setIsOutOfStock] = useState(false);
    const [soldOutModal, setSoldOutModal] = useState<any>(false);
    const [showInfoModal, setShowInfoModal] = useState<any>(false);
    const [showDiscardAppleCare, setShowDiscardAppleCare] = useState<any>(false);
    const [items, setItems] = useState<any>([]);
    const [graphQlCheck, setGraphQlCheck] = useState<any>("false");
    const [totalAmount, setTotalAmount] = useState<any>("");
    const [cartProductId, setCartProductId] = useState<any>("");
    const [SKUId, setSKUId] = useState<any>("");
    const [appleCareCheck, setAppleCareCheck] = useState<any>("false");
    const [acOneTime, setAcOneTime] = useState<any>({});
    const [acMonthly, setAcMonthly] = useState<any>({});
    const [modalDescription, setModalDescription] = useState<any>(t("InfoModalMessage"));
    const [productPrice, setProductPrice] = useState<any>("");
    const [productPricedutyFreeAlteredAmount, setProductPricedutyFreeAlteredAmount] = useState<any>("");
    const [totalProductPrice, setTotalProductPrice] = useState<any>({});
    const [priceBreakdownArr, setPriceBreakdownArr] = useState<any>([]);
    const [productInstallmentPrice, setProductInstallmentPrice] = useState<any>("");
    const scId = scData?.id;
    const ocId = scData?.offerContainer[0]?.id;
    const appleCareCart = scData?.offerContainer[0].cartItem?.filter((item: any) => {
        if (item?.product?.name.includes("AppleCare+ warranty one time")) {
            return item;
        } else if (item?.product?.name.includes("AppleCare+ warranty recurring")) {
            return item;
        }
    })?.[0];
    const acWithoutTaxPrice = appleCareCart?.itemTotalPrice?.[0]?.price?.dutyFreeAlteredAmount?.value;
    const [errorTitle, setErrorTitle] = useState('');
    const [errorModal, setErrorModal] = useState(false)
    const [backOrderElgibility, setBackOrderElgibility] = useState("false");
    const [backOrderDate, setBackOrderDate] = useState('')
    const [itemName, setItemName] = useState("");
    const [productCategory, setProductCategory] = useState("");
    const [promotion, setPromotion] = useState({
        promotionDefault: false,
        promotionDiscountedPrice: 0,
        promotionDiscountedPriceWithoutVAT: 0,
        promotionStartDate: "",
        promotionEndDate: "",
        promotionStatus: "Inactive",
        promotionTextEn: "",
        promotionTextAr: "",
        promotionTimer: false,
    });
    // console.log("Promotion Data:", promotion);
    const updatePromotion = (data: Partial<typeof promotion>) => {
        setPromotion((prev) => ({
            ...prev,
            ...data,
        }));
    };

    const wasActiveRef = useRef(false);
    const promotionExpiredRef = useRef(false);

    // Runs when promotion data arrives/changes
    useEffect(() => {
        if (!promotion?.promotionEndDate) return;

        const now = currentTime;
        const endTime = new Date(promotion.promotionEndDate).getTime();

        wasActiveRef.current = now < endTime;
        promotionExpiredRef.current = false;
    }, [promotion?.promotionEndDate]);

    // Runs every second
    useEffect(() => {
        if (!promotion?.promotionEndDate) return;

        const endTime = new Date(promotion.promotionEndDate).getTime();

        if (
            wasActiveRef.current &&
            !promotionExpiredRef.current &&
            currentTime >= endTime
        ) {
            promotionExpiredRef.current = true;
            handleDeleteProduct();
        }
    }, [currentTime, promotion?.promotionEndDate]);
    const [preBackOrderStatus, setPreBackOrderStatus] = useState(false);

    useEffect(() => {
        if (productId.length > 0) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            graphqlApi(productId)
                .then((res: any) => {
                    if (res.status === 200 && res.data) {
                        dispatch({ type: "PRODUCT_DATA", payload: { productData: res?.data?.data } });
                        let technicalProductName = res?.data?.data?.getProductOfferByID?.[0]?.name;
                        let oneTimeSetupFeeCartItem = scData?.offerContainer[0]?.cartItem.filter((cartItem: any) => (cartItem?.product?.name === technicalProductName))[0];
                        let oneTimeSetupFee = oneTimeSetupFeeCartItem ? oneTimeSetupFeeCartItem?.itemTotalPrice?.filter((price: any) => (price?.priceType === 'Onetime'))[0]?.price?.dutyFreeAmount?.value : null;
                        setProductPrice(oneTimeSetupFee);
                        let oneTimeSetupFeedutyFreeAltered = oneTimeSetupFeeCartItem ? oneTimeSetupFeeCartItem?.itemTotalPrice?.filter((price: any) => (price?.priceType === 'Onetime'))[0]?.price?.dutyFreeAlteredAmount?.value : null;
                        setProductPrice(oneTimeSetupFee);

                        setProductPricedutyFreeAlteredAmount(oneTimeSetupFeedutyFreeAltered);
                        const attachment =
                            res.data.data.getProductOfferByID[0].attachment.filter(
                                (item: any) => item.name === "ShortImage"
                            )[0];
                        const img_url = window.location.origin.includes("localhost")
                            ? `http://ssta004:8080${attachment?.url}`
                            : window.location.origin + attachment?.url;
                        setProductImage(img_url);

                        const responseData = res?.data?.data?.getProductOfferByID[0];
                        const productNameFilterEn = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Commercial name English"
                        )[0];
                        const productNameFilterAr = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Commercial name Arabic"
                        )[0];
                        const colorFilterEn = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Color Value English"
                        )[0];
                        const colorFilterAr = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Color Value Arabic"
                        )[0];
                        const capacityFilter = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Capacity"
                        )[0];
                        let preorderFilter = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Is Eligible For Pre Order"
                        )[0];
                        let backorderFilter = responseData?.specCharValueUse.filter(
                            (val: any) => (val.name === 'Is Eligible For Back Order'
                            ))[0];
                        let SKU = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "SKU"
                        )[0]?.specCharacteristicValue[0]?.value;
                        setSKUId(SKU ? SKU : "");

                        // Promotion related filters

                        const promotionStatusFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) => val.name === "Promotion Status",
                            )[0];

                        const promotionTextArFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) => val.name === "Promotion Text Arabic",
                            )[0];

                        const promotionStartDateFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) => val.name === "Promotion Start Date",
                            )[0];

                        const promotionEndDateFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) => val.name === "Promotion End Date",
                            )[0];

                        const promotionTextEnFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) =>
                                    val.name === "Promotion Text English",
                            )[0];

                        const promotionDiscountedPriceFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) =>
                                    val.name === "Special Discounted Price",
                            )[0];

                        const promotionDiscountedPriceWithoutVATFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) =>
                                    val.name ===
                                    "Special Discounted Price Without VAT",
                            )[0];

                        const promotionTimerFilter =
                            responseData?.specCharValueUse.filter(
                                (val: any) => val.name === "Timer Flag",
                            )[0];
                        updatePromotion({
                            promotionDiscountedPrice:
                                promotionDiscountedPriceFilter
                                    ?.specCharacteristicValue?.[0]?.value || 0,
                            promotionDiscountedPriceWithoutVAT:
                                promotionDiscountedPriceWithoutVATFilter
                                    ?.specCharacteristicValue?.[0]?.value || 0,
                            promotionStartDate:
                                promotionStartDateFilter
                                    ?.specCharacteristicValue?.[0]?.value || "",
                            promotionEndDate:
                                promotionEndDateFilter?.specCharacteristicValue?.[0]
                                    ?.value || "",
                            promotionStatus:
                                promotionStatusFilter?.specCharacteristicValue?.[0]
                                    ?.value || "Inactive",
                            promotionTimer: promotionTimerFilter?.specCharacteristicValue?.[0]
                                ?.value === "true",
                            promotionTextEn:
                                promotionTextEnFilter?.specCharacteristicValue?.[0]?.value?.includes("SAR")
                                    ? promotionTextEnFilter.specCharacteristicValue[0].value.replace(
                                        /SAR/g,
                                        t("SAR")
                                    )
                                    : promotionTextEnFilter?.specCharacteristicValue?.[0]?.value || "",
                            promotionTextAr:
                                promotionTextArFilter?.specCharacteristicValue?.[0]?.value?.includes("SAR")
                                    ? promotionTextArFilter.specCharacteristicValue[0].value.replace(
                                        /SAR/g,
                                        t("SAR")
                                    )
                                    : promotionTextArFilter?.specCharacteristicValue?.[0]?.value || "",

                        });
                        // updatePromotion({
                        //     promotionStartDate: "2026-08-06 10:00:00",
                        //     promotionEndDate: "2026-08-06 15:54:59",
                        //     promotionStatus: "Active",
                        //     promotionTimer: true,
                        // });

                        let appleCareFilter = responseData?.specCharValueUse.filter(
                            (val: any) => val.name === "Apple Care"
                        )[0];
                        setAppleCareCheck(appleCareFilter?.specCharacteristicValue[0]?.value
                            ? appleCareFilter?.specCharacteristicValue[0]?.value
                            : "false")

                        const productNameEn = productNameFilterEn
                            ?.specCharacteristicValue[0]?.value
                            ? productNameFilterEn?.specCharacteristicValue[0]?.value
                            : "";
                        const productNameAr = productNameFilterAr
                            ?.specCharacteristicValue[0]?.value
                            ? productNameFilterAr?.specCharacteristicValue[0]?.value
                            : "";
                        const colorNameEn = colorFilterEn?.specCharacteristicValue[0]?.value
                            ? colorFilterEn?.specCharacteristicValue[0]?.value
                            : "";
                        const colorNameAr = colorFilterAr?.specCharacteristicValue[0]?.value
                            ? colorFilterAr?.specCharacteristicValue[0]?.value
                            : "";
                        const capacity = capacityFilter?.specCharacteristicValue[0]?.value
                            ? capacityFilter?.specCharacteristicValue[0]?.value
                            : "";
                        const capacityVal = capacity
                            ? capacity.replace(/GB/g, t("GB"))
                            : "";
                        // stockStatus can be Long Delivery Time / Out of Stock / In Stock
                        const stockStatus = responseData?.stock?.warehouseStatus
                            ? responseData?.stock?.warehouseStatus
                            : "Out of Stock";
                        let isEligibileForPreOrder = preorderFilter
                            ?.specCharacteristicValue[0]?.value
                            ? preorderFilter?.specCharacteristicValue[0]?.value
                            : "false";
                        let isEligibileForBackOrder = backorderFilter
                            ?.specCharacteristicValue[0]?.value
                            ? backorderFilter?.specCharacteristicValue[0]?.value
                            : "false";
                        // let isEligibileForPreOrder = 'false';
                        // let isEligibileForBackOrder = 'false';
                        let backorderDateFilter = res?.data?.data
                            ?.getProductOfferByID?.[0]?.specCharValueUse?.filter((val: any) => (val?.name === 'Back Order Delivery Date'))?.[0];
                        let backorderDate = backorderDateFilter
                            ?.specCharacteristicValue[0]?.value ? backorderDateFilter?.specCharacteristicValue[0]?.value : "";

                        let brandFilter =
                            res?.data?.data?.getProductOfferByID[0]?.specCharValueUse.filter(
                                (val: any) => val.name === "Brand"
                            )[0];
                        let brandName = brandFilter?.specCharacteristicValue[0]?.value
                            ? brandFilter?.specCharacteristicValue[0]?.value
                            : "";
                        let itemCategoryFilter =
                            res?.data?.data?.getProductOfferByID[0]?.specCharValueUse.filter(
                                (val: any) => val.name === "Device SubType"
                            )[0];
                        let itemCategory = itemCategoryFilter?.specCharacteristicValue[0]
                            ?.value
                            ? itemCategoryFilter?.specCharacteristicValue[0]?.value
                            : "";
                        let itemCategoryVal = itemCategory;
                        let variantId = res?.data?.data?.getProductOfferByID[0]?.id?.key;
                        let productCategory =
                            res?.data?.data?.getProductOfferByID[0]?.category;
                        let seriesId = productCategory[productCategory.length - 1]?.id
                            ? productCategory[productCategory.length - 1]?.id
                            : "";
                        let cartPId = responseData?.id?.key;
                        setCartProductId(cartPId ? cartPId : "");

                        if (itemCategory === "Smart Phones") {
                            itemCategoryVal = "Phones";
                        } else if (itemCategory === "Smart Watches") {
                            itemCategoryVal = "Wearables";
                        }

                        let cartTotalPrice = scData.cartTotalPrice.filter(
                            (price: any) => price.priceType === "Onetime"
                        )[0].price;
                        let totalAmountWithtax =
                            cartTotalPrice?.taxIncludedAlteredAmount?.value;
                        setTotalAmount(totalAmountWithtax);

                        const itemData = [
                            {
                                item_name: productNameEn,
                                item_category: itemCategoryVal,
                                price: totalAmountWithtax,
                                apple_care: "no",
                                item_id: seriesId,
                                item_variant: variantId,
                                index: 0,
                                item_brand: brandName,
                                currency: "SAR",
                                item_list_name: "Phones and Accessories",
                                quantity: 1,
                                discount: "",
                                discount_type: "",
                            },
                        ];
                        setProductCategory(itemCategory)
                        setItemName(productNameEn)
                        setItems(itemData);
                        setGraphQlCheck("true");
                        setProductName(rtl ? productNameAr : productNameEn);
                        setColor(rtl ? colorNameAr : colorNameEn);
                        setCapacity(capacityVal);
                        // enable below line for pre order label
                        setPreOrderElgibility(isEligibileForPreOrder);
                        setBackOrderElgibility(isEligibileForBackOrder)
                        const isoDateBO = backorderDate;
                        const dateObjBO = new Date(isoDateBO);
                        const dayBO = dateObjBO.getUTCDate();
                        const monthBO = dateObjBO.getUTCMonth() + 1;
                        const yearBO = dateObjBO.getUTCFullYear();
                        const formattedDateBO = `${dayBO < 10 ? '0' + dayBO : dayBO}/${monthBO < 10 ? '0' + monthBO : monthBO}/${yearBO}`;
                        setBackOrderDate(backorderDate ? formattedDateBO : "")
                        setIsOutOfStock(stockStatus === "Out of Stock" ? true : false);
                        dispatch({
                            type: "STOCK_STATUS",
                            payload: {
                                outOfStock: stockStatus === "Out of Stock" ? true : false,
                            },
                        });
                        if (againGraphQl === true) {
                            const itemDataBeginCheckout = [
                                {
                                    item_name: productNameEn,
                                    item_category: itemCategoryVal,
                                    price: totalAmountWithtax,
                                    apple_care: "no",
                                    item_id: seriesId,
                                    item_variant: variantId,
                                    index: 0,
                                    coupon: "",
                                    item_brand: brandName,
                                    currency: "SAR",
                                    item_list_name: "Phones and Accessories",
                                    quantity: 1,
                                    discount: "",
                                    discount_type: "",
                                },
                            ];
                            addDataLayer(
                                "begin_checkout_device",
                                "Checkout",
                                "Begin checkout",
                                itemDataBeginCheckout
                            );
                            if (stockStatus === "Out of Stock") {
                                setSoldOutModal(true);
                            } else {
                                dispatch({ type: "LOADER", payload: { loading: true } });
                                window.location.href = checkoutUrl;
                            }
                        }
                    } else {
                        handleApiError(res);
                    }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                })
                .catch((err) => {
                    if (err?.response) {
                        const status = err?.response?.status;
                        const data = err?.response?.data
                        if (status === 500 && data?.errors?.[0]?.extensions?.code === "UNAUTHENTICATED") {
                            dispatch({ type: 'LOADER', payload: { loading: false } });
                            setErrorModal(true)
                            setErrorTitle(t('graphqlErrorTitle1'))
                        } else {
                            handleApiError(err)
                        }
                    } else {
                        handleApiError(err)
                    }
                });
        }
    }, [dispatch, productId, rtl, t, againGraphQl]);

    const now = currentTime;
    //   console.log("Current Time cart:", new Date(now).toLocaleString());

    const isPromotionActive =
        promotion?.promotionStatus === "Active" &&
        now >= new Date(promotion?.promotionStartDate).getTime() &&
        now < new Date(promotion?.promotionEndDate).getTime();
    const offerBadge = isPromotionActive
        ? rtl
            ? promotion?.promotionTextAr
            : promotion?.promotionTextEn
        : "";
    console.log("Promotion productPricedutyFreeAlteredAmount:", productPricedutyFreeAlteredAmount);
    const offerPrice = isPromotionActive && productPricedutyFreeAlteredAmount > 0 ? (
        <>
            {t("SAR")}{productPricedutyFreeAlteredAmount} {" "}
            <span>{productPrice}</span>
        </>
    ) : (
        <>
            {t("SAR")} {productPrice}
        </>
    );

    const offerTimer =
        isPromotionActive && promotion?.promotionTimer
            ? `${t("Offer_Ends_In")} ${getRemainingTime(
                promotion?.promotionEndDate,
                currentTime,
            )}`
            : "";




    useEffect(() => {
        if (graphQlCheck === "true") {
            addDataLayer("view_cart_device", "Cart", "device details", items);
        }
    }, [graphQlCheck]);

    const handleDeleteProduct = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        // If cart has more then 1 product then add condtion to check no of items before deleting cookies
        win.MixpanelTracker.trackEvent("Product Removed from Cart", {
            product_category: productCategory,
            product_name: itemName,
        })
        addDataLayer("remove_from_cart_device", "Cart", "product details", items);
        const req = {
            scId: scData?.id,
            ocId: scData?.offerContainer[0].id,
            cId: scData?.offerContainer[0].cartItem[0].id,
        };
        deleteCartItemApi(req, scData)
            .then((response) => {
                const config = Object.assign(response?.config, { serviceName: 'deleteShoppingCart' });
                const res = { ...response, config }

                if (res.status === 200 && res.data) {
                    deleteCookie("device-count");
                    deleteCookie("device-scId");
                    deleteCookie("device-xCoId");
                    deleteCookie("device-poid");
                    deleteCookie("device-journeyName");
                    setShoppingCartId("");
                    setDeleteModal(false);
                    if (win?.updateCartItemCount) {
                        win?.updateCartItemCount(0);
                    }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setEmptyFlag(false)
                } else {
                    handleApiError(res);
                }
            }).catch((err) => {
                const config = Object.assign(err?.config, { serviceName: 'deleteShoppingCart' });
                const error = { ...err, config }
                handleApiError(error);
            });
    };

    const comma = color.length > 0 && capacity.length > 0 ? "," : "";
    const productDescription = `${color.length > 0 ? color : ""}${comma} ${capacity.length > 0 ? capacity : ""}`;
    const additionalAttributes = scData?.offerContainer[0]?.additionalAttributes;
    const installmentMonths = additionalAttributes?.find((item: any) => item.name === "Commitment Period En")?.value.split(" ")[0];
    const installmenAmount = additionalAttributes?.find((item: any) => item.name === "Installment Amount En")?.value.split(" ")[0];
    const ftiMonthlyCommitmentAmt = forwardTradeInData?.FTIInstalmentMonthlyWithVat;
    const ftiPromotionCommitmentPeriod = forwardTradeInData?.FTICommitmentPeriod;
    const ftiTotalAmountWithVat = <>
        {t("SAR")} {forwardTradeInData?.TotalFTIAmountWithVat}
    </>




    useEffect(() => {
        const priceAlterationArray = scData?.offerContainer[0]?.cartItem[0]?.itemPrice[0]?.priceAlteration;
        const subsidyAmount = isSubsidyApplied ? `- ${priceAlterationArray?.[0]?.price?.discount?.value}` : 0;

        const totalDeviceInstallment = additionalAttributes.find((attr: any) => attr.name === "TotalDeviceInstallmentAmount");


        const deviceInstallmentAmount = isInstallmentApplied ? `- ${totalDeviceInstallment?.value?.split(" ")?.[0]}` : "0";
        const ftiDeviceInstallmentAmount = isFTIApplied ? `- ${forwardTradeInData?.TotalFTIInstalment}` : "0";
        const updatedSubTotalAmount = isInstallmentApplied ? deviceInstallmentAmount?.replace(/-\s*/, '') : productPrice;
        const productInstallmentPrice = isInstallmentApplied ? `${t("SAR")} ${totalDeviceInstallment?.value?.split(" ")?.[0]}` : "0";
        setProductInstallmentPrice(productInstallmentPrice);

        setTotalProductPrice(scData?.cartTotalPrice?.[0]?.price);
        const appleCarePrice = selectedAcPlan?.acName?.includes("AppleCare+ warranty recurring") ? 0 : acWithoutTaxPrice
        const ftiDownpaymentItem = scData?.offerContainer[0].cartItem?.find(
            (item: any) => item?.product?.name === "FTI Downpayment"
        );

        const ftiDownpayment = ftiDownpaymentItem?.itemTotalPrice?.[0]?.price?.dutyFreeAlteredAmount?.value ?? null;

        let priceBreakdown = [
            { name: t("Subtotal"), price: isFTIApplied ? forwardTradeInData?.TotalFTIAmount : isPromotionActive ? productPricedutyFreeAlteredAmount : updatedSubTotalAmount, id: 'subTotal' },
            { name: t("Future_Trade_In_Value"), price: ftiDeviceInstallmentAmount, id: 'deviceFtiInstallment' },
            { name: t("apple_care_plus"), price: appleCarePrice, id: 'appleCare' },
            { name: t("device_subsidy"), price: subsidyAmount, id: 'deviceSubsidy' },
            { name: t("Tamara_fee"), price: tamaraFee, id: 'tamaraFee' },
            { name: t("device_installment"), price: deviceInstallmentAmount, id: 'deviceInstallment' },
            { name: t("Delivery"), price: 0, id: 'delivery' },
            { name: t("Downpayment"), price: ftiDownpayment, id: 'downpayment' },
            { name: t("15%_VAT"), price: scData?.cartTotalPrice?.[0]?.price?.taxAmount, id: 'vat' },
        ];

        if (!isSubsidyApplied) {
            // below filter is to remove the subsidy line if not applied
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.name !== t("device_subsidy")
            );
        }
        if (isfindInBranch) {
            // below filter is to remove the delivery if find in branch
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.name !== t("Delivery")
            );
        }

        if (!isInstallmentApplied) {
            // below filter is to remove the installment line if not applied
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.id !== t("deviceInstallment")
            );
        }
        if (!isFTIApplied) {
            // below filter is to remove the fti line if not applied
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.id !== t("deviceFtiInstallment")
            );
        }
        if (ftiDownpayment == null || ftiDownpayment <= 0)
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.name !== t("Downpayment")
            );
        if (!tamaraFee) {
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.name !== t("Tamara_fee")
            );
        }

        if (!appleCareApplied) {
            priceBreakdown = priceBreakdown.filter(
                (item) => item?.name !== t("apple_care_plus")
            );
        }

        setPriceBreakdownArr(priceBreakdown)
    }, [scData, productPrice, isfindInBranch])


    const addDataLayer = (event: string, screenType: string, screenName: string, itemsVal: any) => {
        if (event === "begin_checkout_device") {
            win.dataLayer.push({
                event: event,
                ecommerce: {
                    user_id: "",
                    login_type: "not_logged_in",
                    screen_type: screenType,
                    screen_name: screenName,
                    language_selected: rtl ? "AR" : "EN",
                    currency: "SAR",
                    value: totalAmount,
                    tax: "15% vat",
                    items: itemsVal,
                },
            });
        } else {
            win.dataLayer.push({
                event: event,
                ecommerce: {
                    user_id: "",
                    login_type: "not_logged_in",
                    screen_type: screenType,
                    screen_name: screenName,
                    language_selected: rtl ? "AR" : "EN",
                    currency: "SAR",
                    items: itemsVal,
                },
            });
        }
    };

    const handleSoldOut = () => {
        setSoldOutModal(false);
    };

    function handleModalClose(): void {
        setShowInfoModal(false)
    }

    function handleOpenInfoModal(val: any): void {
        if (appleCareApplied === true) {
            if (val === "icon") {
                setShowDiscardAppleCare(true);
            } else {
                const appleCare = scData?.offerContainer[0].cartItem?.filter((item: any) => {
                    if (item?.product?.name.includes("AppleCare+ warranty one time")) {
                        return item;
                    } else if (item?.product?.name.includes("AppleCare+ warranty recurring")) {
                        return item;
                    }
                })?.[0];
                const acPrice = appleCare?.itemTotalPrice?.[0]?.price?.taxIncludedAlteredAmount?.value;
                if (selectedAcPlan?.acName?.includes("AppleCare+ warranty one time")) {
                    setModalDescription(t("yearly_coverage_added_modal", { ac_yearly_amount: acPrice }))
                } else if (selectedAcPlan?.acName?.includes("AppleCare+ warranty recurring")) {
                    setModalDescription(t("monthly_coverage_added_modal", { ac_monthly_amount: acPrice }))
                }
                setShowInfoModal(true);
            }
        } else {
            dispatch({ type: "LOADER", payload: { loading: true } });
            POQAPI();
        }
    }

    const removeAppleCareAPI = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        const acItemContainer = scData?.offerContainer[0]?.cartItem.filter((item: any) => (item?.product?.name?.includes("AppleCare+ ")));
        const ciId = acItemContainer?.[0]?.id ? acItemContainer?.[0]?.id : "";
        // const acId = acItemContainer?.[0]?.productOffering?.id ? acItemContainer?.[0]?.productOffering?.id : "";
        // const acName = acItemContainer?.[0]?.productOffering?.name ? acItemContainer?.[0]?.productOffering?.name : "";

        removeAppleCare(scId, ocId, ciId)
            .then((response: any) => {
                const config = Object.assign(response?.config, { serviceName: 'removeAppleCare' });
                const res = { ...response, config }

                if (res.status === 200 && res?.data) {
                    dispatch({ type: "APPLECARE_APPLIED", payload: { appleCareApplied: false } });
                    dispatch({ type: 'SC_RESPONSE', payload: { scData: res.data } })
                    dispatch({ type: "SELECTED_AC_PLAN", payload: { selectedAcPlan: {} } });
                    setShowDiscardAppleCare(false);
                    if (isFTIApplied) {
                        setAppleCareCheck(false);
                    }
                    if (isSubsidyApplied || isInstallmentApplied || isFTIApplied) {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: true } });
                        captureDataApi(scData);
                    }
                } else {
                    handleApiError(res);
                }
            }).catch((err: any) => {
                const config = Object.assign(err?.config, { serviceName: 'removeAppleCare' });
                const error = { ...err, config }
                handleApiError(error);
            })
    }

    const POQAPI = () => {
        POQ(scData, ocId)
            .then((res: any) => {
                if (res.status === 200 && res?.data) {
                    setShowInfoModal(true)
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    const productOffers = res?.data?.productOfferingQualificationItemContainer[0]?.productOfferingQualificationItem ?
                        res?.data?.productOfferingQualificationItemContainer[0]?.productOfferingQualificationItem : [];
                    const oneTimeObj = productOffers?.filter((item: any) => (item?.productOffering?.name.includes("AppleCare+ warranty one time")))?.[0];
                    const monthlyObj = productOffers?.filter((item: any) => (item?.productOffering?.name.includes("AppleCare+ warranty recurring")))?.[0];
                    setAcOneTime({
                        acId: oneTimeObj?.productOffering?.id, acName: oneTimeObj?.productOffering?.name,
                        price: oneTimeObj?.productOffering?.productOfferingPrice?.[0]?.tax?.[0]?.taxAmount?.value
                    });
                    setAcMonthly({
                        acId: monthlyObj?.productOffering?.id, acName: monthlyObj?.productOffering?.name,
                        price: monthlyObj?.productOffering?.productOfferingPrice?.[0]?.tax?.[0]?.taxAmount?.value
                    });
                } else {
                    handleApiError(res);
                }
            }).catch((err: any) => {
                handleApiError(err);
            })
    }

    const openAppleCareDetails = () => {
        window.open(`https://www.apple.com/${rtl ? 'sa-ar' : 'sa'}/support/products/iphone/`, '_blank')
    }

    const getSelectedAcPlan = (planName: any) => {
        dispatch({ type: "SELECTED_AC_PLAN", payload: { selectedAcPlan: planName === "AppleCare+ warranty one time" ? acOneTime : acMonthly } });
        dispatch({ type: "SELECTED_PLAN_NAME", payload: { planName } });

        if (isSubsidyApplied || isInstallmentApplied || isFTIApplied || (planName === "AppleCare+ warranty one time")) {
            dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "DeviceTerms" } });
        } else if (planName === "AppleCare+ warranty recurring") {
            dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "login" } });
        }
    }

    const captureDataApi = (scData: any) => {
        const sections: any = ({
            ...captureStructure,
            steps: captureStructure?.steps.map((step: any) => ({
                ...step,
                offerContainerId: scData.offerContainer[0].id,
                options: [
                    {
                        name: 'Login',
                        value: 'Mobily number',
                        fields: [
                            {
                                name: 'Mobily number',
                                value: ""
                            }
                        ]
                    }
                ],
                fields: step.fields.map((field: any) => {
                    let fieldValues = field;

                    if (field.name === 'Continue As Guest') {
                        fieldValues = ({
                            ...field,
                            value: 'Yes'
                        })
                    } else if (field.name === 'OTP') {
                        fieldValues = ({
                            ...field,
                            value: ""
                        })
                    } else if (field.name === 'CustomerRelatedAcccountInquiryResponse') {
                        fieldValues = ({
                            ...field,
                            value: JSON.stringify({})
                        })
                    } else if (field.name === 'MobilyMSISDN') {
                        fieldValues = ({
                            ...field,
                            value: '' //pass encrpty BMNumber value when using ID Number in Login
                        })
                    } else if (field.name === 'NewStack') {
                        fieldValues = ({
                            ...field,
                            value: "N"
                        })
                    } else if (field.name === 'deviceInstallment') {
                        fieldValues = ({
                            ...field,
                            value: "false"
                        })
                    }
                    else if (field.name === 'deviceFtiInstallment') {
                        fieldValues = ({
                            ...field,
                            value: "false"
                        })
                    }

                    return fieldValues
                })
            }))
        });

        captureData(scData, [sections])
            .then((res: any) => {
                if (res?.status === 200 && res?.data) {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    handleApiError(res);
                }
            }).catch(err => {
                handleApiError(err);
            })
    }

    const handleGraphqlError = () => {
        dispatch({
            type: "LOADER", payload: { loading: true }
        });
        setErrorModal(false);
        document.body.style.overflow = 'auto';
        window.location.reload();
    }

    const handleOrderViaDelivery = () => {
        setPreBackOrderStatus(false)
        setIsFindInBranch(false);
        setPreBackOrderDisabled(false);
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    const handlePreBackOrderStatus = () => {
        setPreBackOrderStatus(false)
        setIsFindInBranch(true)
        setPreBackOrderDisabled(true);
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    useEffect(() => {
        if (isfindInBranch) {
            if (
                preOrderElgibility === 'true' || backOrderElgibility === 'true'
            ) {
                setPreBackOrderStatus(true);
            } else {
                setPreBackOrderStatus(false);
            }
        }
    }, [isfindInBranch])

    return (
        <>
            {showInfoModal && (
                <ErrorModal
                    id={"infoAppleCareModal"}
                    rtl={false}
                    title={t("Add_AppleCare_coverage")}
                    description={modalDescription}
                    firstButtonText={t("got_it")}
                    ConfirmModalClose={CloseIcon}
                    onClickClose={handleModalClose}
                    showCloseIcon={true}
                    modalFirstButtonClick={handleModalClose}
                >
                    <div className="ReadMoreText" onClick={openAppleCareDetails}>
                        <Typography>{t("Read_more")}</Typography>
                    </div>
                    <AppleCareImage />

                    {!appleCareApplied && (
                        <div>
                            <div className="CardSeparetor"></div>
                            {acMonthly?.acId && (
                                <>
                                    <ShadowContainer
                                        cardTitle={t("monthly_coverage")}
                                        cardSubTitle={t("ac_monthly", {
                                            ac_monthly_amount: acMonthly?.price,
                                        })}
                                        buttonTitle={t("CHOOSE")}
                                        selectedAcPlan={() => {
                                            getSelectedAcPlan("AppleCare+ warranty recurring");
                                        }}
                                    />
                                    <div className="ModalDescription">
                                        <Typography>{t("Recurring_subscription")}</Typography>
                                    </div>
                                </>
                            )}
                            {acOneTime?.acId && (
                                <ShadowContainer
                                    cardTitle={t("two_years_coverage")}
                                    cardSubTitle={t("ac_two_years", {
                                        ac_two_years_amount: acOneTime?.price,
                                    })}
                                    buttonTitle={t("CHOOSE")}
                                    selectedAcPlan={() => {
                                        getSelectedAcPlan("AppleCare+ warranty one time");
                                    }}
                                />
                            )}
                        </div>
                    )}
                </ErrorModal>
            )}
            {(soldOut || preBackOrderDisabled) && (
                <div className="QtyInfo_Box CartPage">
                    <img src={ExclamMark} alt="mark" />
                    <Typography className="Stock_Availability">
                        {t("This_device_is_not_available")}{" "}
                    </Typography>
                </div>
            )}

            <div className="CartPage__Section">
                <div style={{ display: "none" }} id="cartProductId">
                    {cartProductId}
                </div>
                <div style={{ display: "none" }} id="SKUId">
                    {SKUId}
                </div>

                <ConfirmModal
                    id="discardAppleCareModal"
                    idBtn="discardAppleCareModalContinue"
                    idCloseIcon="discardAppleCareModalClose"
                    showModal={showDiscardAppleCare}
                    title={t("Discard_AppleCare_coverage")}
                    subTitle={t("Apple_protection_Message_for_2Years")}
                    subText={""}
                    buttonName={t("CONTINUE_WITH_COVERAGE")}
                    outlineButtonName={t("DISCARD_COVERAGE")}
                    onclickButton={() => {
                        setShowDiscardAppleCare(false);
                    }}
                    onclickOutLineButton={() => {
                        removeAppleCareAPI();
                    }}
                    showOutlineButton={true}
                    showIcon={false}
                ></ConfirmModal>
                <ConfirmModal
                    id="cartPagesErrorModal"
                    idBtn="cartPagesErrorModalContinue"
                    idCloseIcon="cartPagesErrorModalClose"
                    showModal={soldOutModal}
                    title={t("some_items_sold_out")}
                    subTitle={t("review_cart_before")}
                    subText={""}
                    buttonName={t("got_it")}
                    onclickButton={handleSoldOut}
                    showOutlineButton={false}
                    showIcon={false}
                ></ConfirmModal>
                <ConfirmModal
                    id="cartErrorModal"
                    idBtn="cartErrorModalContinue"
                    idCloseIcon="cartErrorModalClose"
                    showModal={deleteModal}
                    title={t("remove_item_from_cart")}
                    subTitle={""}
                    subText={""}
                    buttonName={t("remove")}
                    outlineButtonName={t("cancel")}
                    onclickButton={handleDeleteProduct}
                    onclickOutLineButton={() => {
                        setDeleteModal(false);
                    }}
                    showOutlineButton={true}
                    showIcon={false}
                ></ConfirmModal>

                <div
                    className={`ProductDetailsCard_container ProductDetailsCard_container_${isOutOfStock === true ? "noStock" : ""}`}
                >
                    <ProductDetailsCard
                        rtl={rtl}
                        count="1X"
                        status={preOrderElgibility === "true" ? t("pre_order") : ""}
                        borderON={true}
                        beforeDiscount=""
                        devicesImage={productImage}
                        productDescription={productDescription}
                        productName={productName.length > 0 ? productName : ""}
                        productPrice={
                            isOutOfStock
                                ? t("sold_out")
                                : (isInstallmentApplied
                                    ? productInstallmentPrice
                                    : (isFTIApplied ? ftiTotalAmountWithVat : offerPrice))
                        }
                        specification=" 128GB"
                        Trashicon={false}
                        handleTrashicon={() => setDeleteModal(true)}
                        deleteItem={isOutOfStock ? true : false}
                        deleteColor="#DB4076"
                        promotionTextTitle={
                            isInstallmentApplied
                                ? `${t("installment")} ${installmenAmount} ${t("sar_month")} (${t("vat_exclusive")})`
                                : (isFTIApplied ? `${t("installment")} ${ftiMonthlyCommitmentAmt} ${t("sar_month")}` : "")
                        }
                        promotionTextSubtitle={
                            isInstallmentApplied
                                ? `(${installmentMonths} ${t("months_commitment")})`
                                : (isFTIApplied ? `(${ftiPromotionCommitmentPeriod} ${t("months_commitment")})` : "")
                        }
                        backorderText={
                            backOrderElgibility === "true"
                                ? `${t("Expected_Delivery")} ${backOrderDate}`
                                : ""
                        }
                        offerBadge={offerBadge}
                        offerTimer={offerTimer}
                    >
                        {appleCareCheck === "true" ? (
                            <>
                                <div className="CardSeparetor"></div>
                                <AppleCoverage
                                    handleOpenInfoModal={handleOpenInfoModal}
                                    rtl={rtl}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                    </ProductDetailsCard>
                </div>

                <OrderSummary
                    rtl={rtl}
                    products={priceBreakdownArr}
                    orderPriceData={totalProductPrice}
                    ftiMonthlyCommitmentAmt={ftiMonthlyCommitmentAmt ?? ""}
                    ftiPromotionCommitmentPeriod={ftiPromotionCommitmentPeriod ?? ""}
                />

                {errorModal && (
                    <ErrorModal
                        id="error-select-variant"
                        rtl={rtl}
                        title={errorTitle}
                        description={t("")}
                        firstButtonText={t("got_it")}
                        modalFirstButtonClick={handleGraphqlError}
                    />
                )}

                {preBackOrderStatus && (
                    <ErrorModal
                        id={"Branch_not_Found"}
                        rtl={rtl}
                        title={t("Available_via_delivery")}
                        description={t("Available_via_delivery_Info")}
                        firstButtonText={t("order_via_delivery")}
                        modalFirstButtonClick={handleOrderViaDelivery}
                        secButtonText={t("got_it")}
                        modalSecondButtonClick={handlePreBackOrderStatus}
                    />
                )}
            </div>
        </>
    );
}

export default CartPage;